import { connect } from 'react-redux'
import { IGlobalState } from '../../Root/store/appReducer'
import {
  getActivityListTab,
  getActivityListTypeTab,
  getActivityListTabSetAt,
} from '../../views/Activity/store/ActivitySelectors'
import { GoalWithProgress, Role } from '../../services/api.types'
import { IYumGoalListDispatchProps, IYumGoalListProps, YumGoalList } from './YumGoalList'
import { hasAnyRole } from '../../common/auth/authSelectors'
import { setActivityListTab, setActivityListTypeTab } from '../../views/Activity/store/ActivityActions'
import { userCompaniesSelector } from '../../views/Settings/store/SettingsSelectors'

export interface IOwnProps {
  goals: GoalWithProgress[]
  loading: boolean
}

const mapStateToProps = (state: IGlobalState, ownProps: IOwnProps): IYumGoalListProps => {
  const { goals, loading } = ownProps
  return {
    goals,
    loading,
    activityListTab: getActivityListTab(state),
    activityListTypeTab: getActivityListTypeTab(state),
    activityListTabSetAt: getActivityListTabSetAt(state),
    hasAnyRole: (roles: Role[]) => hasAnyRole(state, roles),
    userCompanies: userCompaniesSelector(state),
  }
}

const mapDispatchToProps: IYumGoalListDispatchProps = {
  setActivityListTab,
  setActivityListTypeTab,
}

export default connect(mapStateToProps, mapDispatchToProps)(YumGoalList)
